module.exports = __webpack_public_path__ + "img/cbd1blur.6c788658.jpg";